module.exports = __webpack_public_path__ + "static/media/miniCrossword.3dfbcc4b.svg";